/* --------------------------------------------------------------------------------------
   xwTable.directive.js
   Copyright © 2021 Xerox Corporation. All Rights Reserved.

   Copyright protection claimed includes all forms and matters of copyrightable material
   and information now allowed by statutory or judicial law or hereinafter granted,
   including without limitation, material generated from the software programs which
   are displayed on the screen such as icons, screen display looks, etc.
   -------------------------------------------------------------------------------------
*/

/*eslint semi: ["error", "never"]*/
 export class xwTable {
  /*@ngInject*/
  constructor (appSettings) {
    this.restrict = 'A'
    this.scope = {
      bordered: '<',
      interactive: '<',
      selectable: '<',
      readonly: '<',
      sortable: '<'
    }
    this.appSettings = appSettings
  }
  link(scope, elem, attrs) {
    setTimeout(() => elem.first().xrxtable(this.getOptions(attrs, scope)))
  }
  getOptions(attrs, scope) {
    return {
      theme: attrs.theme? attrs.theme : this.appSettings.primaryColor,
      bordered: scope.bordered,
      interactive: scope.interactive,
      selectable: scope.selectable,
      readonly: scope.readonly,
      scroll: attrs.scroll,
      height: attrs.height,
      width: attrs.width,
      widgetSize: attrs.widgetSize,
      sortable: scope.sortable
    }
  }
  static directiveFactory(appSettings) {
    xwTable.instance = new xwTable(appSettings)
    return xwTable.instance
  }
}



// WEBPACK FOOTER //
// ./src/app/xrxWrappers/xwTable.directive.js